import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import { selectUser, selectUserId } from '@/store/selectors/auth';
import { fetchAdminInfoThunk } from '@/store/thunks/auth/fetchAdminInfoThunk';
import { decodeJWT } from '@/utils/jwtDecoder';
import { getSessionToken } from '@/utils/sessionStorage';

interface UseAdminProfileReturn {
  profile: ReturnType<typeof selectUser>;
  isLoading: boolean;
}

/**
 * Custom hook for managing admin profile data.
 * Automatically fetches admin info if not already loaded.
 *
 * @returns Object containing profile data and loading state
 */
export const useAdminProfile = (): UseAdminProfileReturn => {
  const userId = useSelector(selectUserId);
  const profile = useSelector(selectUser);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if(userId !== "") {
      const token = getSessionToken() ?? '';
      const { payload } = decodeJWT<{ id: string }>(token);
      const { id } = payload;
      let userUUID = '';
      if (typeof id === 'string' && id !== '') {
        userUUID = id;
      }
      void dispatch(fetchAdminInfoThunk({ id: userUUID }));
    }
  }, [userId, dispatch]);
  return {
    profile,
    isLoading: userId === '',
  };
};
